import { eventBus } from "@/main";
import EventCenter from "@/utils/EventCenter";

// eslint-disable-next-line no-undef

export default {
  __name: 'ButtonAICompHandler',
  props: {
    command: {
      type: String,
      required: true
    }
  },
  setup(__props) {
    const props = __props;
    function openAiComp() {
      eventBus.$emit(EventCenter.PropsParamSuggestByAIReplyComp, props.command);
    }
    return {
      __sfc: true,
      props,
      openAiComp
    };
  }
};